import React, { useState, useEffect, useRef } from "react";
import KotServiceService from "Service/Kot/KotService.service";
import Title from "Components/Card/title";
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Divider,
  Tabs,
  Tab,
  Checkbox,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText
} from "@mui/material";
import ShowKot from "./showkot";
import Swal from "sweetalert2";
import InventoryIcon from "@mui/icons-material/Inventory";
import { KOT_STATUS } from "Components/Constants/KotStatus";
import toast, { Toaster } from "react-hot-toast";
import Pusher from "pusher-js";
import DinnerDiningIcon from '@mui/icons-material/DinnerDining';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import useSound from 'use-sound'; 
import kotSound from "./audio/kot-sound.mp3"
import errorSound from "./audio/error-sound.mp3"
import xpErrorSound from "./audio/xpError-sound.mp3"
import { realtime } from "index";
import { useChannel } from "ably/react";
import { INVOICE_TYPE_CODE } from "Components/Constants/InvoiceTypeCode";
import { useDispatch } from "react-redux";
import { openSnackbar } from "Redux/Actions/snackbarActions";
import { handleError } from "Helper/handleError";
import Loading from "Components/MUI_components/loading";
import KotCardView from "./KotCardView";
import { CHANNEL_NAMES, EVENT_NAMES } from "Components/Constants/ChannelNames";
import { ITEM_DEPARTMENT_CODES } from "Components/Constants/ItemDepartment";
import { getCompletedKots, getCreatedKots, getProcessingKots, getReversedKots } from "Helper/kot";
import { debounce } from "lodash";


export const kotBgColorBasedOnType = (invoiceType) => {
    switch (invoiceType) {
      case INVOICE_TYPE_CODE.TAKE_AWAY:
        return "#FE9200"; // Dark yellow
      case INVOICE_TYPE_CODE.DELIVERY:
        return "#009830"; // Green
      default:
        return "#02B9A1";
    }
}


const Booking = () => {
  const dispatch = useDispatch()

  const [kots, setKots] = useState([]);
  const [completedKots, setCompletedKots] = useState([]);
  const [processingKots, setProcessingKots] = useState([]);
  const [reversedKots, setReversedKots] = useState([])
  const [itemTotals, setItemTotals] = useState({});
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedItem, setSelectedItem] = useState();
  const [isItemChecked, setIsItemChecked] = useState();
  const [loading, setLoading] = useState(false)

  const { publish } = useChannel(CHANNEL_NAMES.KOT_PARTIALLY_PROCESSING)

  const REVERSAL_TEXT_COLOR = "#30002C"

  const soundBtnRef = useRef(null)
  const errorSoundBtnRef = useRef(null)

  const [play] = useSound(kotSound)
  const [playXpErrorSound] = useSound(xpErrorSound)

  useEffect(() => {
    fetchKots();
  }, []);

  useEffect(() => {
    const channel = realtime.channels.get(CHANNEL_NAMES.CREATE_KOT);
    const partialProcessingChannel = realtime.channels.get(CHANNEL_NAMES.KOT_PARTIALLY_PROCESSING)

    const kotCreateListner = (data) => {
      const validKotUpdate =
        data?.data?.invoiceStatus == KOT_STATUS.KOT_CREATE ||
        data?.data?.invoiceType == INVOICE_TYPE_CODE.TAKE_AWAY ||
        data?.data?.invoiceType == INVOICE_TYPE_CODE.DELIVERY;

      const filteredMainKitchenItems =
        // If kot generated via dine
        data?.data?.stockHistoryTemps?.length > 0
          ? data?.data?.stockHistoryTemps?.filter((stockHistory) => {
              return (
                stockHistory.itemMaster.departmentCode ==
                ITEM_DEPARTMENT_CODES.MAIN_KITCHEN
              );
            })
          : // If kot generated via invoice (take-away / delivery)
            data?.data?.stockHistories?.length > 0
            ? data?.data?.stockHistories?.filter((stockHistory) => {
                return (
                  stockHistory.itemMaster.departmentCode ==
                  ITEM_DEPARTMENT_CODES.MAIN_KITCHEN
                );
              })
            : [];

      if (
        filteredMainKitchenItems.length !== 0 &&
        data?.name == EVENT_NAMES.CREATE_KOT &&
        validKotUpdate
      ) {
        soundBtnRef?.current?.click();
        // fetchKots()
      } else if (data?.name == CHANNEL_NAMES.KOT_REVERSAL) {
        errorSoundBtnRef?.current?.click();
      }
      fetchKots()
      // const debouncedFetchKots = debounce(fetchKots, 500);
      // debouncedFetchKots();
    };

    const partialProcessingListner = (data) => {
      if (
        data?.data?.invoiceStatus == KOT_STATUS.KOT_PARTIALLY_PROCESSING ||
        data?.data?.invoiceStatus == KOT_STATUS.KOT_PROCESSING || 
        data.name == CHANNEL_NAMES.KOT_COMPLETE
      ) {
        fetchKots();
      }
    }

    channel.subscribe(kotCreateListner);
    partialProcessingChannel.subscribe(partialProcessingListner)

    return () => {
      channel.unsubscribe(kotCreateListner);
      partialProcessingChannel.unsubscribe(partialProcessingListner)
    };

  }, [realtime]);

  const fetchKots = async () => {
    try {
      setLoading(true)
      const res = await KotServiceService.getkotShow();
      
      const data = res?.map((row) => {
        return {
          ...row, 
          stockHistoryTemps:row.stockHistoryTemps?.filter((stockHistory) => {
          return stockHistory?.itemMaster?.departmentCode == ITEM_DEPARTMENT_CODES.MAIN_KITCHEN
        })}
      })

      const filteredData = getCreatedKots(data);

      const completedData = getCompletedKots(data);

      const processingData = getProcessingKots(data);

      const reversedData = getReversedKots(data);
    
      setLoading(false)

      setKots(filteredData);
      setCompletedKots(completedData);
      setProcessingKots(processingData);
      setReversedKots(reversedData)
      aggregateItemQuantities(filteredData);
    } catch (e) {
      dispatch(openSnackbar(true, 'error', handleError(e)))
    } finally {
      setLoading(false)
    }
  };

  const aggregateItemQuantities = (kots) => {
    const totals = {};
    kots.forEach((kot) => {
      kot.stockHistoryTemps.forEach((item) => {
        const itemName = item.itemMaster.name;
        const quantity = parseFloat(item.quantity);

        if (totals[itemName]) {
          totals[itemName] += quantity;
        } else {
          totals[itemName] = quantity;
        }
      });
    });
    setItemTotals(totals);
  };

  const handleComplete = async (kot) => {
    try {

      const payload = {
        code: kot.code,
        departmentCode: ITEM_DEPARTMENT_CODES.MAIN_KITCHEN,
      };

      setLoading(true)
      const res = await KotServiceService.completeKot(payload);
      // console.log(res?.kot);
      
      publish(CHANNEL_NAMES.KOT_COMPLETE, res?.kot)
      
      toast.success("KOT completed successfully")
      setLoading(false)
      fetchKots();
    } catch (e) {
      dispatch(openSnackbar(true, 'error', handleError(e)))
    }
  };

  const handleProcessKot = async (kot) => {
    try {
        const payload = {
          code: kot.code,
          departmentCode: ITEM_DEPARTMENT_CODES.MAIN_KITCHEN
        }

        setLoading(true)
        const res = await KotServiceService.processKot(payload);

        publish(CHANNEL_NAMES.KOT_PARTIALLY_PROCESSING, res?.kot)

        toast.success("KOT moved to kitchen successfully")
        setLoading(false)
        fetchKots();
    } catch (e) {
        dispatch(openSnackbar(true, "error", handleError(e)));
    }
  };

  const getStatusColor = (invoiceStatus) => {
    
    switch (invoiceStatus) {
      case KOT_STATUS.KOT_COMPLETE:
        return "#7b241c"; // red
      case KOT_STATUS.KOT_CREATED_BY_INVOICE:
        return "#2F324C"; // blue
      case KOT_STATUS.KOT_COMPLETE_WITH_INVOICE:
        return "#515a5a"; // grey
      case KOT_STATUS.KOT_REVERSED:
        return REVERSAL_TEXT_COLOR;
      default:
        return "#126550"; // green
    }
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleSelectItem = (item, itemStatus) => {
    // setSelectedItem(item);
    // console.log("Item name: ", item);
    // console.log("Item status: ", itemStatus);
    
    
  }

  const totalKots = kots.length + completedKots.length;
  const newKots = kots.length;
  const completedKotsCount = completedKots.length;

  return (
    <>
      <Toaster position="top-center" reverseOrder={false}/>
      <Title 
        showConnection 
        showInfo 
        infoMsg={"Please double-tap the KOT No. button to print the corresponding KOT."}
      >
        KOT Dashboard
      </Title>
      
      <button
        type="button"
        ref={soundBtnRef}
        onClick={() => play()}
        hidden
      >
        Sound
      </button>
      <button
        type="button"
        ref={errorSoundBtnRef}
        // onClick={() => playErrorSound()}
        onClick={() => playXpErrorSound()}
        hidden
      >
        Error Sound
      </button>
      <Box display="flex" justifyContent="space-between" position="relative">
        <Box sx={{ width: "80%" }}>
          <Tabs value={selectedTab} onChange={handleTabChange}>
            <Tab label="Active KOTs" />
            <Tab label="Processing KOTs" />
            <Tab label="Complete KOTs" />
            <Tab label="Reversed KOTs" />
          </Tabs>
          {selectedTab === 0 && (
            <Box
              sx={{
                columnCount: { xs: 1, sm: 2, md: 3 },
                columnGap: "16px",
                width: "100%",
                mt: 2,
              }}
            >
              {loading ? (
                <Box sx={{ mt: 3 }}>
                  <Loading />
                </Box>
              ) : (
                kots.map((kot) => {
                  const kotColor = kotBgColorBasedOnType(kot.invoiceType);
                  // console.log(kot?.subKotCounts);  
                  return (
                    <KotCardView 
                      key={kot.code} 
                      kot={kot} 
                      kotColor={kotColor}
                      showProcessingButton
                      showCompleteButton
                      handleComplete={handleComplete}
                      handleProcessKot={handleProcessKot}
                      fetchKot={fetchKots}
                      departmentCode={ITEM_DEPARTMENT_CODES.MAIN_KITCHEN}
                    />
                  );
                })
              )}

            </Box>
          )}
          {/* partial kot */}
          {selectedTab === 1 && (
            <Box
              sx={{
                columnCount: { xs: 1, sm: 2, md: 3 },
                columnGap: "16px",
                width: "100%",
                mt: 2,
              }}
            >
              {processingKots.map((kot) => {
                // console.log(kot.invoiceStatus);
                const kotColor = getStatusColor(kot.invoiceStatus)
                return (
                  <KotCardView 
                    key={kot.code}
                    kot={kot}
                    kotColor={kotColor}
                    showCompleteButton
                    handleComplete={handleComplete}
                    fetchKot={fetchKots}
                    departmentCode={ITEM_DEPARTMENT_CODES.MAIN_KITCHEN}
                  />
                )
              })}
            </Box>
          )}

          {selectedTab === 2 && (
            <Box
              sx={{
                columnCount: { xs: 1, sm: 2, md: 3 },
                columnGap: "16px",
                width: "100%",
                mt: 2,
              }}
            >
              {completedKots.map((kot) => {
                const kotColor = getStatusColor(kot.invoiceStatus)
                return (
                  <KotCardView 
                    key={kot.code} 
                    kot={kot} 
                    kotColor={kotColor}
                    fetchKot={fetchKots} 
                    departmentCode={ITEM_DEPARTMENT_CODES.MAIN_KITCHEN}
                  />
                )
              })}
            </Box>
          )}

          {selectedTab === 3 && (
            <Box
              sx={{
                columnCount: { xs: 1, sm: 2, md: 3 },
                columnGap: "16px",
                width: "100%",
                mt: 2,
              }}
            >
              {reversedKots.map((kot) => {
                const kotColor = getStatusColor(kot.invoiceStatus)
                return (
                  <KotCardView 
                    key={kot.code} 
                    kot={kot} 
                    kotColor={kotColor}
                    fetchKot={fetchKots}
                    preventPrint
                    departmentCode={ITEM_DEPARTMENT_CODES.MAIN_KITCHEN}
                  />
                )
              })}
            </Box>
          )}
        </Box>
        <Card
          sx={{
            width: "15%",
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
            boxShadow: 3,
            position: "fixed",
            right: "20px",
          }}
        >
          <CardContent>
            <div style={{ position: "fixed", height: "40px" }}>
              <Typography
                variant="h6"
                gutterBottom
                sx={{ fontWeight: "bold", textAlign: "center" }}
              >
                <InventoryIcon color="primary" /> Total Quantities
              </Typography>
            </div>
            <Divider sx={{ my: 2 }} />
            <Box sx={{ my: 2 }}>
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                Total KOTs: {totalKots}
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontWeight: "bold", color: "#126550" }}
              >
                Active KOTs: {newKots}
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontWeight: "bold", color: "#7b241c" }}
              >
                Completed KOTs: {completedKotsCount}
              </Typography>

              <Typography
                variant="body1"
                sx={{ fontWeight: "bold", color: "#7b241c" }}
              >
                PC: Print Count
              </Typography>

              <Typography
                variant="body1"
                sx={{ fontWeight: "bold", color: REVERSAL_TEXT_COLOR }}
              >
                Total Reversals: {reversedKots?.length}
              </Typography>
            </Box>
            <Divider sx={{ my: 2 }} />
            <div
              style={{
                overflowY: "scroll",
                height: "300px",
                marginTop: "50px",
              }}
            >
              {Object.entries(itemTotals).map(([itemName, totalQuantity]) => (
                <Box
                  key={itemName}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    my: 1,
                  }}
                >
                  <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                    {itemName}:
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ color: "primary.main", fontWeight: "bold" }}
                  >
                    {totalQuantity.toFixed(2)}
                  </Typography>
                </Box>
              ))}
            </div>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default Booking;
